export module SwissAppConfigModels {

    export interface WebServiceConfig {
        host?: string | null;
        adrUrl: string;
        anwUrl: string;
        manUrl: string;
        dokuUrl: string;
        objUrl: string;
        userUrl: string;
        boardUrl: string;
        picUrl: string;
        mesUrl: string;
        saUrl: string;
        termUrl: string;
        aufgUrl: string;
        noteUrl: string;
        tishUrl: string;
        weUrl: string;
    }

    export interface SwissAppConfig {
        presetObjectDescription: string;
        presetObjectNote4: string;
        richTextFormat_ManuDesc: number;
        richTextFormat_Memo: number;
        richTextFormat_Memo2: number;
        richTextFormat_SA_Memo: number;
        richTextFormat_AdrNote: number;
        swissSettingsFilePath: string;
        adressConfigFilePath: string;
        timeGridStart: string;
        timeGridEnd: string;
        timeGridWorkDayStart: string;
        timeGridWorkDayEnd: string;
        startPage: number;
        objViewConfig: number;
        uploadNecessary: boolean;
        pdfToolsKey: string;
        advancedObjSearch: boolean;
        vinaIntern: boolean;
        orderFilterObjView6?: string;
        showObjectStatusColorInTree: boolean;
    }

    export interface SwissAppUserConfig {
        mandantID: string;
        employeeID: number;
        timeGridStart: string;
        timeGridEnd: string;
        timeGridWorkDayStart: string;
        timeGridWorkDayEnd: string;
        startPage: number;
        objViewConfig?: number;
        uploadNecessary: boolean;
        orderFilterObjView6?: string;
        showObjectStatusColorInTree: boolean;
    }

    export interface SwissAppMandant {
        mandatorID: string;
        description: string;
        default: boolean;
        spesenartMaterialEinkauf: string;
        spesenartMaterialEinkauf_ID?: number;
        kostenstelleMaterialEinkauf: string;
        kostenstelleMaterialEinkauf_ID: number;
        checkListePath: string;
        companyName: string;
        street: string;
        houseNumber: string;
        zip: string;
        city: string;
        phone: string;
        vatNumber: string;
        autoRecommendationWorkPlace?: string
    }

    export class EmptyMandant implements SwissAppMandant {
        mandatorID = '';
        description = '';
        default = true;
        spesenartMaterialEinkauf = '';
        kostenstelleMaterialEinkauf = '';
        kostenstelleMaterialEinkauf_ID = 0;
        checkListePath = '';
        companyName = '';
        street = '';
        houseNumber = '';
        zip = '';
        city = '';
        phone = '';
        vatNumber = '';

        constructor() {
        }
    }

    export interface SwissAppReport {
        mandator: string;
        iD_SwissAppReport: number;
        description: string;
        iD_SwissAppReportType: number;
        formularType: number;
        pdfReportHeaderLogo: string;
        pdfFormularConfigJSONData: string;
        printPositionsTable: boolean;
        pdfTemplatePath: string;
    }
}
